/* eslint-disable max-len */
export const OCC_ENDPOINTS = {
  environment: 'infra/environment',
  menu: 'cms/menu?fields=DEFAULT',
  promoCoupon: 'promotions/code',
  baseSitesForConfig:
    'basesites?fields=DEFAULT,baseSites(defaultPreviewCatalogId,defaultPreviewArticleCode,defaultPreviewCategoryCode,defaultPreviewProductCode,urlEncodingAttributes,urlPatterns,name,stores(FULL))',
  baseSites:
    'basesites?fields=DEFAULT,baseSites(defaultPreviewCatalogId,defaultPreviewArticleCode,defaultPreviewCategoryCode,defaultPreviewProductCode,urlEncodingAttributes,urlPatterns,name,stores(FULL))',
  categoryDetails: '/catalogs/${catalogId}/${catalogVersionId}/categories/${categoryId}',
  tags: '/tags',
  tag: '/tags/${slug}',
  badges: '/badges/${badgeCode}',
  featureFlag: '/config/flag',
};

export const UNKNOWN_ENDPOINT = 'unknown';
